import { __decorate } from "tslib";
import { Mixins, Component } from 'vue-property-decorator';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import PageTitle from '@/components/v2/PageTitle.vue';
import LinkButton from '@/components/link_button/Index.vue';
import PageTransition from '@/components/page_transition/Index.vue';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import AppDetailsMixin from '@/helpers/vue_mixins/v2/ecommerce/AppDetailsMixin';
import { Bundle } from '@/helpers/entities/enums/v2/Bundle';
import { STORE_MANAGEMENT } from '@/helpers/constants/CustomBundleKeys';
import { OVERVIEW_ROUTE, PERFORMANCE_ROUTE } from '@/helpers/constants/StoreManagerRoutes';
import { ECOMMERCE_OVERVIEW_ROUTE, ECOMMERCE_PERFORMANCE_ROUTE, SHOPIFY_OVERVIEW_ROUTE, SHOPIFY_PERFORMANCE_ROUTE, INSURANCE_OVERVIEW_ROUTE, INSURANCE_PERFORMANCE_ROUTE, } from '@/helpers/constants/B2CRoutes';
let Overview = class Overview extends Mixins(RouterParamsAppMixin, ViewportSizeMixin, AppDetailsMixin) {
    get getKycClass() {
        if (this.xsOnly && !!this.appDetails && !!this.appDetails.appliesKyc) {
            return 'pa-0 mr-0';
        }
        return '';
    }
    /**
     * Store Manager Dashboard Checker
     * @author Peter John Alvarado <peterjohn@gorated.ph>
     * @since Version {0.21.0}
     */
    get isStoreManager() {
        return this.bundleKey === STORE_MANAGEMENT;
    }
    get overviewRoute() {
        if (this.isStoreManager) {
            return OVERVIEW_ROUTE.name;
        }
        if (this.bundleKey === Bundle.Ecommerce) {
            return ECOMMERCE_OVERVIEW_ROUTE;
        }
        if (this.bundleKey === Bundle.Shopify) {
            return SHOPIFY_OVERVIEW_ROUTE;
        }
        if (this.bundleKey === Bundle.Insurance) {
            return INSURANCE_OVERVIEW_ROUTE;
        }
        return null;
    }
    get performanceRoute() {
        if (this.isStoreManager) {
            return PERFORMANCE_ROUTE.name;
        }
        if (this.bundleKey === Bundle.Ecommerce) {
            return ECOMMERCE_PERFORMANCE_ROUTE;
        }
        if (this.bundleKey === Bundle.Shopify) {
            return SHOPIFY_PERFORMANCE_ROUTE;
        }
        if (this.bundleKey === Bundle.Insurance) {
            return INSURANCE_PERFORMANCE_ROUTE;
        }
        return null;
    }
};
Overview = __decorate([
    Component({
        components: {
            PageTitle,
            LinkButton,
            PageTransition,
        },
    })
], Overview);
export default Overview;
